<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="supplierSiteForm"
    (ngSubmit)="saveSupplierSite()"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-truck mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <label for="supplierSiteName" class="block text-900 font-medium mb-2">Supplier Site Name</label>
          <input id="supplierSiteName" type="text" pInputText formControlName="supplierSiteName" class="w-full" />
          <small *ngIf="supplierSiteForm.get('supplierSiteName')?.invalid && supplierSiteForm.get('supplierSiteName')?.touched" class="p-error">
            Supplier Site Name is required.
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <label for="supplierSiteNumber" class="block text-900 font-medium mb-2">Supplier Site Number</label>
          <input id="supplierSiteNumber" type="text" pInputText formControlName="supplierSiteNumber" class="w-full" />
        </div>

        <div class="field col-12 md:col-6">
          <label for="erpSupplierSiteId" class="block text-900 font-medium mb-2">Erp Supplier Site Id</label>
          <input id="erpSupplierSiteId" type="text" pInputText formControlName="erpSupplierSiteId" class="w-full" />
        </div>

        <app-entity-dropdown-picker
          formControlName="supplier"
          [adapter]="supplierPickerAdapter"
          inputId="supplier"
          label="Supplier"
          placeholder="Select a Supplier"
          filterPlaceholder="Filter suppliers"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-truck"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="business"
          [adapter]="businessPickerAdapter"
          inputId="business"
          label="Business"
          placeholder="Select a Business"
          filterPlaceholder="Filter businesses"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-building"
        ></app-entity-dropdown-picker>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <p-button label="Cancel" styleClass="p-button-secondary" type="button" (onClick)="cancel()"></p-button>
      <p-button [label]="isEditMode ? 'Update Supplier Site' : 'Save Supplier Site'" type="submit" [disabled]="supplierSiteForm.invalid"></p-button>
    </div>
  </form>
</div>
